import type { FaireProductEntity } from "../../entity_types/product";

export const p_6xvawh324h: FaireProductEntity = {
  token: "p_6xvawh324h",
  type: "product",
  name: "Celestial Star Cubic Zirconia CZ Chain Double Stud Earrings",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/b8683b2d1f6e4af408c8aae5593c39cdd9dfb7a6728867c5a9223ee5733ec105.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27b560ce6d052546b737e6fba89e0ba93a935d5b143321b59ee824518dcd2f95.jpeg",
    "https://cdn.faire.com/fastly/f36963d772b86db53d00ee5fda7452eb87bf53ae6d299ddeaf1c41b22153aad6.jpeg",
    "https://cdn.faire.com/fastly/6b97354eca39205f1d3c791e04719594ca251bef259905d6b28dd71a6bfcdc08.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "\nCreating your handcrafted jewelry pieces starts here! This is the best place to shop for fashionable and stylish jewelry findings with premium quality and competitive prices! Take a look at more detailed information about this item:\n\nDescription:\n- Material: 24K Gold Plated over Brass, Cubic Zirconia\n- Size: 6.1mm x 6.1mm & 5.2mm x 4.9mm\n- Quantity: 1 pair\n- Color: Gold\n\n\nLead Nickel Free\n\n",
  tags: [],
  msrpDollars: 13.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:27.825Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
